import { ChapterSection } from "../ServicesMenuChapter.interface";
import { SectionHeaderProps } from "../components/SectionHeader";

export const CAROUSEL_ITEM_PADDING = 2.6; // 50px
export const CAROUSEL_ITEM_MEDIA_WIDTH = 51.04; // 980px
export const CAROUSEL_ITEM_HEADER_HEIGHT = 6.41; // 123
export const CAROUSEL_ITEM_ACTIVATION_DELAY = 2;

export interface SectionLayoutProps {
    section: ChapterSection,
    headerSettings: SectionHeaderProps,
    isEntrySection: boolean,
}
